<template>
  <div
    class="h-screen form_filter text-justify w-full fixed overflow-hidden top-0 left-0 bg-white z-[50000] max-w-vw p-4 pb-16"
    v-show="isFilterFormOpen"
    v-if="currentBreakpoint !== 'lg'"
  >
    <div class="mobile-max-height overflow-y-auto overflow-x-hidden h-full">
      <div class="block mb-31px">
        <div class="flex items-center justify-between">
          <span
            class="back-btn inline-flex items-center cursor-pointer text-16 -ml-2"
            @click="toggleMobileFilterForm"
          >
            <i
              class="vs-icon notranslate icon-scale feather icon-chevron-left null vs-icon-secondary text-24 mr-1.5"
            ></i>
            <span>Back</span>
          </span>
          <span class="font-bold text-18 text-onyx-lightest" ref="filters">
            Filters
          </span>

          <span>
            <clear-refinements />
          </span>
        </div>
      </div>
      <div class="main-filter">
        <refinement-list :param-prop="paramProp">
          <template #header="{ header }">
            <p class="head-text text-onyx-lightest text-21 mb-8px h-25px">
              {{ header }}
            </p>
          </template>
        </refinement-list>
      </div>
      <div class="h-40px">&nbsp;</div>
      <primary-button
        class="filter-update-btn text-16 fixed bottom-0 w-full z-[50001] h-12 mx-auto mt-24px mb-5px max-w-320 -translate-x-1/2 left-1/2 font-montserrat"
        @click="onUpdateFilter"
        >Update</primary-button
      >
    </div>
  </div>
  <section
    v-else
    class="container-filters cards-container hidden lg:block w-327px min-w-327px max-w-736"
  >
    <div class="sticky top-8px z-10">
      <div class="hidden lg:block">
        <AutoComplete
          :param-prop="paramProp"
          v-if="currentBreakpoint === 'lg'"
        />
      </div>

      <div class="jobs-list overflow-hidden relative">
        <scroll-shadow>
          <div class="job-cards mt-32px">
            <div class="hidden lg:block">
              <jobs-breadcrumbs
                  :param-prop="paramProp"
                  v-if="currentBreakpoint === 'lg'" />
            </div>
            <div class="mx-4 lg:mx-0">
              <div class="lg:pt-5">
                <div
                  class="pb-5 container-header flex items-center justify-between"
                >
                  <h3 class="text-21 font-medium">Filters</h3>
                  <clear-refinements />
                </div>

                <div class="container-body">
                  <refinement-list :param-prop="paramProp" />
                </div>
              </div>
            </div>
          </div>
        </scroll-shadow>
      </div>
    </div>
  </section>
</template>

<script>
import AutoComplete from './AutoComplete.vue';
import ClearRefinements from './ClearRefinements.vue';
import JobsBreadcrumbs from './JobsBreadcrumbs.vue';
import RefinementList from './RefinementList.vue';
import ScrollShadow from './ScrollShadow.vue';

export default {
  name: 'JobsFilters',
  components: {
    AutoComplete,
    ClearRefinements,
    JobsBreadcrumbs,
    RefinementList,
    ScrollShadow,
  },
  props: {
    currentBreakpoint: {
      type: String,
      required: true,
    },
    paramProp: {
      default: undefined,
    },
  },
  data() {
    return {
      isFilterFormOpen: false,
    };
  },
  methods: {
    toggleMobileFilterForm() {
      this.isFilterFormOpen = !this.isFilterFormOpen;

      if (this.isFilterFormOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'visible';
      }

      const filtersModal = this.$refs.filters;

      if (filtersModal) {
        filtersModal.scrollIntoView();
      }
    },
    onUpdateFilter() {
      window.scrollTo(0, 0);
      this.toggleMobileFilterForm();
    },
  },
  mounted() {
    this.$root.$on('openMobileFilters', () => {
      this.toggleMobileFilterForm();
    });
  },
};
</script>
<style lang="scss" scoped>
.mobile-max-height {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.mobile-max-height::-webkit-scrollbar {
  display: none;
}

.filter-update-btn {
  transform: translateX(-50%);
}
</style>
